import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=9caf742c&scoped=true&"
import script from "./Return.vue?vue&type=script&lang=js&"
export * from "./Return.vue?vue&type=script&lang=js&"
import style0 from "./Return.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Return.vue?vue&type=style&index=1&id=9caf742c&scoped=true&lang=css&"
import style2 from "./Return.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caf742c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VImg,VTextField})
